/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotActivityBase extends models.CopilotActivityCountBase {
    getFixupPrototypeFunction() { return CopilotActivityBase.fixupPrototype; }

    static newInstance(model: Partial<CopilotActivityBase>): CopilotActivityBase {
        let obj = Object.assign(new CopilotActivityBase(), model);
        CopilotActivityBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotActivityBase>): CopilotActivityBase {
        if (!model) return null;
        return CopilotActivityBase.newInstance(<CopilotActivityBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotActivityBase) {
        if (!obj) return;

        models.CopilotActivityBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotActivityBase): boolean {
        if (models.CopilotActivityCountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotActivityBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.lines_of_code_modified === undefined) {
            this.lines_of_code_modified = 0;
        }
        if (this.lines_of_code_suggested_to_modified === undefined) {
            this.lines_of_code_suggested_to_modified = 0;
        }
    }

    /**
     * Number of lines of code modified
     */
    lines_of_code_modified: number;

    /**
     * Lines of code suggested to modified ratio
     */
    lines_of_code_suggested_to_modified: number;

}
